export const DEFAULT_ORDER_TYPE = Object.freeze({
  id: 'lrc3200',
  name: 'LRC-32xx - up to $20.00',
});
